import business from "./business";
import common from "./common";
import {
  setLeftMenuShow,
  setTopMenuShow,
  setMainHandContentShow,
  setMainRoomContentShow,
  setMainOnlineOrderContentShow,
  setMainAppointOrderContentShow,
  setMainIotDeviceContentShow,
  setBottomAppointOrderSorShow,
  setBottomShiftChangeShow,
  setBottomServiceEndSortShow,
  setBottomPositionChangeShow,
  setRightDetailShow,
  setRightAppointOrderShow,
  setRightCallServeShow,
  setRightBottomBookingShow,
  setRightBottomBirthdayShow,
  setRightAllShow,
  setBottomAllShow,
} from "../reducers/hiddenModule"

let hiddenUtils = {}

hiddenUtils.handleHiddenForEmployee = () => {
  var hiddenlList = business.v4HiddenList

  if (hiddenlList.length <= 0) {
    return;
  }

  for (let i = 0; i < hiddenlList.length; i++) {
    let block = hiddenlList[i]['block']
    block = block.toString()

    if (block === '140') {
      // 左边菜单
      common.dispatch(setLeftMenuShow("no"))
    } else if (block === '150') {
      // 上边菜单
      common.dispatch(setTopMenuShow("no"))
    } else if (block === '160') {
      // 手牌状态
      common.dispatch(setMainHandContentShow("no"))
    } else if (block === '170') {
      // 房间状态
      common.dispatch(setMainRoomContentShow("no"))
    } else if (block === '180') {
      // 网络订单
      common.dispatch(setMainOnlineOrderContentShow("no"))
    } else if (block === '190') {
      // 排钟列表
      common.dispatch(setMainAppointOrderContentShow("no"))
    } else if (block === '200') {
      // 设备状态
      common.dispatch(setMainIotDeviceContentShow("no"))
    } else if (block === '210') {
      // 排钟
      common.dispatch(setBottomAppointOrderSorShow("no"))
    } else if (block === '220') {
      // 换班
      common.dispatch(setBottomShiftChangeShow("no"))
    } else if (block === '230') {
      // 最先下钟
      common.dispatch(setBottomServiceEndSortShow("no"))
    } else if (block === '240') {
      // 调整位置
      common.dispatch(setBottomPositionChangeShow("no"))
    } else if (block === '250') {
      // 详情
      common.dispatch(setRightDetailShow("no"))
    } else if (block === '260') {
      // 叫钟队列
      common.dispatch(setRightAppointOrderShow("no"))
    } else if (block === '270') {
      // 服务信息
      common.dispatch(setRightCallServeShow("no"))
    } else if (block === '280') {
      // 预约信息
      common.dispatch(setRightBottomBookingShow("no"))
    } else if (block === '290') {
      // 生日信息
      common.dispatch(setRightBottomBirthdayShow("no"))
    } else if (block === '300') {
      // 右侧信息
      common.dispatch(setRightAllShow("no"))
    } else if (block === '310') {
      // 下边技师信息
      common.dispatch(setBottomAllShow("no"))
    }

  }
}

export default hiddenUtils